<template>
    <div class="bg-indigo-600" v-if="duels.should_show">
        <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div class="sm:flex items-center justify-between flex-wrap">
                <div class="flex items-center flex-wrap gap-2" :class="{ hidden: duels.pending.length === 0 }">
                    <span class="flex p-2 rounded-lg bg-indigo-800">
                        <!-- Heroicon name: outline/speakerphone -->
                        <svg
                            class="h-6 w-6 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                            />
                        </svg>
                    </span>
                    <p class="ml-3 font-medium text-white truncate">
                        <span class="md:hidden">
                            {{
                                $tc('messages.duels_pending_banner_message', duels.pending.length, {
                                    count: duels.pending.length,
                                })
                            }}
                        </span>
                        <span class="hidden md:inline">
                            {{
                                $tc('messages.duels_pending_banner_message', duels.pending.length, {
                                    count: duels.pending.length,
                                })
                            }}
                        </span>
                    </p>
                    <div class="order-3 mt-2 shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                        <button
                            @click="showModal = true"
                            class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50"
                        >
                            {{ $t('messages.join_in!') }}
                        </button>
                    </div>
                </div>
                <div v-if="duels.last_week_winner !== null">
                    <div class="flex items-center gap-2">
                        <div>
                            <TrophyIcon class="text-yellow-400 h-10 w-10" />
                        </div>
                        <div class="text-white text-xs sm:text-base">
                            {{ duels.last_week_winner.message }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal :show="showModal" @close="showModal = false">
            <div class="flex gap-2 items-center">
                <div><IconVs class="h-10 w-10 text-gray-300" /></div>
                <h2 class="text-lg">
                    {{ $tc('messages.duels', 2) }}
                </h2>
            </div>
            <div class="divide-y-2 divide-gray-100">
                <div class="flex justify-between py-2 gap-2" v-for="duel in duels.pending" :key="duel.id">
                    <div class="flex gap-2">
                        <img :src="duel.avatar_or_default" alt="" class="rounded-full h-10" />
                        <div>
                            <div>{{ duel.message }}</div>
                            <div class="text-xs">{{ duel.title }}</div>
                        </div>
                    </div>
                    <div class="flex justify-between py-2 gap-2 items-center">
                        <InertiaSquareLinkButton :href="duel.links.create" action="quiz" />
                        <InertiaInlineSquareDeleteButton :href="duel.links.delete" />
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaInlineSquareDeleteButton from '@/components/InertiaInlineSquareDeleteButton.vue';
import { IconVs } from '@tabler/icons-vue';
import TrophyIcon from '@/components/Gamification/TrophyIcon.vue';

export default {
    name: 'DuelsDashboardBanner',
    components: {
        TrophyIcon,
        IconVs,
        InertiaInlineSquareDeleteButton,
        Modal,
        InertiaSquareLinkButton,
    },
    props: {
        duels: {
            required: false,
            type: Object,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
};
</script>
